var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ExpandableSettingsItem',{staticClass:"configurable-pages",attrs:{"title":_vm.$t('message.CFG_PAGES'),"use-transition-expand":""}},[_c('ConfigurablePagesList',{on:{"pageClick":_vm.onPageClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }